import { FeatureProtectedView } from '@moniebook-web/components/molecules/feature-protected-view';
import { MoniebookLoader } from '@moniebook-web/components/molecules/moniebook-loader';
import { ProtectedView } from '@moniebook-web/components/molecules/protected-view';
import type { RouteObject } from 'react-router';

import { StyleScope } from '@/features/shared/style-scope';

export const inventoryOnboardingRoutes: RouteObject[] = [
    {
        path: '',
        element: (
            <FeatureProtectedView
                flag='moniebook.pos.inventoryOnboarding'
                loader={<MoniebookLoader fullHeight />}>
                <StyleScope name='inventory-onboarding-ui' />
            </FeatureProtectedView>
        ),
        children: [
            {
                path: 'inventory-onboarding',
                element: (
                    <FeatureProtectedView
                        flag='moniebook.pos.inventoryOnboarding'
                        loader={<MoniebookLoader fullHeight />}>
                        <ProtectedView
                            accessCodeList={['MANAGE_IMPLEMENTER_TOOLS']}
                        />
                    </FeatureProtectedView>
                ),
                children: [
                    {
                        path: 'add-items',
                        async lazy() {
                            const { addNewItemsPage } = await unwrapFeatures();

                            return addNewItemsPage().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'import-file',
                        async lazy() {
                            const { importHistoryPage } =
                                await unwrapFeatures();

                            return importHistoryPage().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'import-file/new',
                        async lazy() {
                            const { importFilePage } = await unwrapFeatures();

                            return importFilePage().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'import-file/details/:cleanupRequestId',
                        async lazy() {
                            const { importFileDetailsPage } =
                                await unwrapFeatures();

                            return importFileDetailsPage().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                ],
            },
            {
                path: 'onboarding/add-items',
                async lazy() {
                    const { addNewItemsPage } = await unwrapFeatures();
                    return addNewItemsPage().then((m) => ({
                        Component: m.default,
                    }));
                },
            },
            {
                path: 'import-file',
                async lazy() {
                    const { importFilePage } = await unwrapFeatures();
                    return importFilePage().then((m) => ({
                        Component: m.default,
                    }));
                },
            },
            {
                path: 'import-file/details/:cleanupRequestId',
                async lazy() {
                    const { importFileDetailsPage } = await unwrapFeatures();
                    return importFileDetailsPage().then((m) => ({
                        Component: m.default,
                    }));
                },
            },
            {
                path: 'onboarding/import-file',
                async lazy() {
                    const { importHistoryPage } = await unwrapFeatures();
                    return importHistoryPage().then((m) => ({
                        Component: m.default,
                    }));
                },
            },
            {
                path: 'onboarding/import-file/new',
                async lazy() {
                    const { importFilePage } = await unwrapFeatures();
                    return importFilePage().then((m) => ({
                        Component: m.default,
                    }));
                },
            },
        ],
    },
];

async function unwrapFeatures() {
    const features = await import('inventoryOnboarding/features');

    return features.default;
}
